import { NodeAPIs } from "../utils/worker";
const { nodeBaseURL } = NodeAPIs;
const nodeAPI = {
  GET_EXCEPTION_REPORT: nodeBaseURL + "/exceptions",
  GET_EXCEPTION_ACTIONS: nodeBaseURL + "/actions",
  GET_EXCEPTION_REASONS: nodeBaseURL + "/reasons",
  UPDATE_EXCEPTION_REPORT: nodeBaseURL + "/exceptions/",
  GET_ALL_BAG_LIST: nodeBaseURL + "/bag-list",
  SHIPMENT_TRACKER_NODE: nodeBaseURL + "/tracking/",
  MANIFEST_DATE_FILTER_NODE: nodeBaseURL + "/consolidated-shipment",

  CREATE_NEW_ROUTE: nodeBaseURL + "/route",
  UPDATE_NEW_ROUTE: nodeBaseURL + "/route/",
  // SHIPMENT_COUNT: nodeBaseURL + "/shipment-count",
  SHIPMENT_COUNT: nodeBaseURL + "/shipmentCountCron?operationTime=",

  SEARCH_ROUTES: nodeBaseURL,
  NEW_LCR_REPORT: nodeBaseURL + "/lcr_dashboard",
  NEW_LCR_REPORT_TRACKING: nodeBaseURL + "/lcr_tracking_dashboard?search=",
  LCRTableDetails: nodeBaseURL + "/lcr_customised_view?LCRId=",
  LCR_DETAILS: nodeBaseURL + "/bag_shipment_details?barcodeNumber=",
  LCR_BAG_SHIPEMNT_DETAILS:
    nodeBaseURL + "/bag_shipment_details?BagOrShipmentNumber=",
  THRESHOLD_POST: nodeBaseURL + "/weight_thresholds",
  ELIGBLE_THRESHOLD: nodeBaseURL + "/weight_thresholds",
  DELETES_BAG_SHIPMENTS: nodeBaseURL + "/shipment_to_bag",
  ADD_BAG_SHIPMENTS: nodeBaseURL + "/shipment_to_bag",
  DASHBOARD_COUNT: nodeBaseURL + "/dashboard-count?date=",
  //Get mcnLabel Print Data
  MCN_LABEL_PRINT:nodeBaseURL + "/tpl-labels/V2",
  NEW_INSCAN_BATCH: nodeBaseURL + "/api/scan/batch", //POST

};
export default nodeAPI;
